import { ComposedText, ComposedTextScoreCard } from "@ptsd/uikit";
import { View } from "tamagui";

import type { SphereComposedText } from "./utils";

export const ComposedTextSphere: React.FC<{ data?: SphereComposedText }> = ({
  data,
}) => {
  if (!data) return null;
  const { description, title, image, score, state, dynamics } = data;

  return (
    <ComposedText.Container
      data-id="composed-text-sphere-container"
      //      maxWidth={920}
    >
      <ComposedText.TextContainer
        data-id="composed-text-sphere-text-container"
        justifyContent="center"
      >
        <ComposedText.Title data-id="composed-text-sphere-title">
          {title}
        </ComposedText.Title>

        <ComposedText.Accordion
          data-id="composed-text-sphere-accordion"
          data={description?.accordion}
        >
          {({ content }) => (
            <View data-id="composed-text-sphere-accordion-content">
              <ComposedText.RenderMd md={content} />
            </View>
          )}
        </ComposedText.Accordion>
        <View data-id="composed-text-sphere-description">
          <ComposedText.RenderMd md={description.md} />
        </View>
      </ComposedText.TextContainer>

      <ComposedText.ScoreContainer>
        <ComposedTextScoreCard.Container
          data-id="composed-text-sphere-score-container"
          paddingVertical={"$10"}
          height={"100%"}
          justifyContent="center"
          width={"100%"}
          gap={"$4"}
        >
          <ComposedTextScoreCard.Image path={image} />
          <View justifyContent="center" alignItems="center" gap="$3">
            <View justifyContent="center" alignItems="center" gap="$0.5">
              <ComposedTextScoreCard.Score
                data-id="composed-text-sphere-score"
                state={state}
              >
                {score}
              </ComposedTextScoreCard.Score>
            </View>
            <ComposedTextScoreCard.Separator />
            <ComposedTextScoreCard.Dynamics
              state={"neutral"}
              description={dynamics.description}
            />
          </View>
        </ComposedTextScoreCard.Container>
      </ComposedText.ScoreContainer>
    </ComposedText.Container>
  );
};
